module.exports = __webpack_public_path__ + "static/media/linkedin-brands-solid.5781cdd4.svg";